
import ReviewStars from "./ReviewStars.vue";

export default {
  name: "ReviewHeader",
  components: {
    ReviewStars,
  },
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
};
